import { BaseError } from './base';

type UnrecognizedNetworkErrorParams = {
  networkId: string;
  originalError: unknown;
  walletProviderKey: string;
};

export class UnrecognizedNetworkError extends BaseError {
  constructor({
    networkId,
    originalError,
    walletProviderKey,
  }: UnrecognizedNetworkErrorParams) {
    const cause = originalError instanceof Error ? originalError : null;

    super({
      cause,
      code: 'unrecognized_network',
      docsUrl: null,
      metaMessages: [`Wallet provider key: ${walletProviderKey}`],
      name: 'UnrecognizedNetworkError',
      shortMessage: `Attempt to switch to unrecognized network of ID ${networkId}. Please enable this network in your dashboard configuration first.`,
    });
  }
}
